import { DecoratorNode, type NodeKey, type SerializedLexicalNode, type Spread } from "lexical";
import { headlessDecorate } from "../headless-decorate";

export type SerializedChannelNode = Spread<
  {
    channel_id: string;
  },
  SerializedLexicalNode
>;

export class ChannelNode extends DecoratorNode<React.JSX.Element> {
  __channel_id: string;

  static getType(): string {
    return "channel";
  }

  constructor(channel_id: string, key?: NodeKey) {
    super(key);
    this.__channel_id = channel_id;
  }

  static clone(node: ChannelNode): ChannelNode {
    return new this(node.__channel_id, node.__key);
  }

  decorate(): React.JSX.Element {
    return headlessDecorate();
  }

  createDOM(): HTMLElement {
    const span = document.createElement("span");
    span.className = "reference channel";
    return span;
  }

  updateDOM(): boolean {
    // force a re-create
    return true;
  }

  exportJSON(): SerializedChannelNode {
    return {
      ...super.exportJSON(),
      type: "channel",
      version: 1,
      channel_id: this.__channel_id,
    };
  }

  static importJSON(serializedNode: SerializedChannelNode): ChannelNode {
    return new this(serializedNode.channel_id);
  }

  isInline(): boolean {
    return true;
  }

  getChannelId(): string {
    return this.__channel_id;
  }
}

export function $isChannelNode(node: unknown): node is ChannelNode {
  return node instanceof ChannelNode;
}
